import { Injectable } from '@angular/core';
import {
  Action,
  SelectorOptions,
  State,
  StateContext,
  createSelector,
} from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Observable, finalize, map, tap } from 'rxjs';
import { PagedListResponse } from 'src/app/_main/helpers/ResponsePayloadMessage';
import { DataSourceRequest } from '../eventer-grid';
import { GridRequesterService } from './grid-requester.service';
export namespace GridActions {
  export class FetchEntries {
    static readonly type = '[Grid Entries] Fetch Entries';
    constructor(
      public id: string,
      public url: string,
      public request: DataSourceRequest
    ) {}
  }
}
export interface GridStateModel {
  presentedEntries?: { [key: string]: any[] };
  totalRecords?: { [key: string]: number };
  loading?: { [key: string]: boolean };
}
@State<GridStateModel>({
  name: 'gridEntries',
  defaults: {
    presentedEntries: {},
    totalRecords: {},
    loading: {},
  },
})
@Injectable()
@SelectorOptions({ injectContainerState: false })
export class GridState {
  constructor(private gridRequesterService: GridRequesterService) {}

  // --------------------------------- SELECTORS ------------------------------
  static loading(id: string): (state: GridStateModel) => boolean {
    return createSelector(
      [GridState],
      (state: GridStateModel) => state.loading[id]
    );
  }

  static presentedEntries(id: string): (state: GridStateModel) => any[] {
    return createSelector(
      [GridState],
      (state: GridStateModel) =>
        state.presentedEntries[id] ?? new Array(10).fill(null)
    );
  }

  static totalRecords(id: string): (state: GridStateModel) => number {
    return createSelector(
      [GridState],
      (state: GridStateModel) => state.totalRecords[id]
    );
  }
  static search(
    id: string,
    fields: string[],
    search: string
  ): (state: GridStateModel) => any[] {
    return createSelector([GridState], (state: GridStateModel) => {
      if (fields.length > 0) {
        let presentedEntries = [];
        fields.forEach((field) => {
          presentedEntries = [
            ...presentedEntries,
            ...state.presentedEntries[id].filter((p) =>
              p[field].toLowerCase().includes(search.toLowerCase())
            ),
          ];
        });
        return presentedEntries;
      } else
        return state.presentedEntries[id].filter((p) =>
          p[fields[0]].toLowerCase().includes(search.toLowerCase())
        );
    });
  }

  // --------------------------------- ACTIONS --------------------------------

  @Action(GridActions.FetchEntries)
  fetchEntries(
    { setState }: StateContext<GridStateModel>,
    { id, url, request }: GridActions.FetchEntries
  ): Observable<PagedListResponse<any>> {
    setState(
      patch<GridStateModel>({
        loading: patch({ [id]: true }),
      })
    );
    return this.gridRequesterService
      .getPage<PagedListResponse<any>>(url, request)
      .pipe(
        map((response) => {
          if (url.indexOf('api/RatePlan/GetRatePlan') >= 0) {
            response.Payload.Data.forEach((item) => {
              if (item['MinDays'] === 0) {
                item['MinDays'] = '-- --' + ' ' + '-- --';
              }
              if (item['MaxDays'] === 0) {
                item['MaxDays'] = '-- --' + ' ' + '-- --';
              }
            });
          }
          if (url.indexOf('api/Product/GetProductFinalizedVariants') >= 0) {
            response.Payload.Data.forEach((item) => {
              if (item['Values'].length == 0) {
                item['Values'].push('No Variants');
              }
            });
          }
          if (url.includes('api/Customer/GetCustomers')||url.includes('api/Staff/GetCustomerStaff')) {
            response.Payload.Data.forEach((item) => {
              item.Status =
                !item.EmailConfirmed && !item.IsDraft
                  ? 1
                  : item.IsActive
                  ? 2
                  : item.IsDraft
                  ? 4
                  : 3;
            });
          }
          if (response.Payload.Data.length > 0) {
            var temp = response.Payload.Data[0];
            if (temp.hasOwnProperty('EmailConfirmed') && temp.hasOwnProperty('IsActivated')) {
              response.Payload.Data.forEach((item) => {
                if (!item.EmailConfirmed) {
                  item.Status = 1;
                } else {
                  if (item.IsActivated) item.Status = 2;
                  else item.Status = 3;
                }
              });
            }
          }
          // if (url.indexOf('api/Staff/GetStaffs') >= 0 || url.indexOf('api/Staff/GetAllUsersForAdmin') >= 0) {
          // response.Payload.Data.forEach((item) => {
          //   if (!item.EmailConfirmed) {
          //     item.Status = 1;
          //   } else {
          //     if (item.IsActivated) item.Status = 2;
          //     else item.Status = 3;
          //   }
          // });
          // }
          if (url.indexOf('api/Staff/GetCustomerStaffByOrgIdForAdmin') >= 0) {
            response.Payload.Data.forEach((item) => {
              if (!item.IsPrimaryAccount) {
                item.Status = 1;
              } else {
                if (item.IsActivated) item.Status = 2;
                else item.Status = 3;
              }
            });
          }

          return response.Payload;
        }),
        tap((result: PagedListResponse<any>) => {
          setState(
            patch<GridStateModel>({
              presentedEntries: patch({ [id]: result.Data }),
              totalRecords: patch({ [id]: result.TotalCount }),
            })
          );
        }),
        finalize(() => {
          setState(
            patch<GridStateModel>({
              loading: patch({ [id]: false }),
            })
          );
        })
      );
  }
}
